<template>
  <div id="app">
    <headerComponent :key="Math.random()"/>
    <router-view :key="Math.random()"/>
    <footerComponent/>
    <button id="back-top" class="back-top" @click="goTop()">TOP</button>
  </div>
</template>

<script>
  import axios from 'axios'

  import headerComponent from './components/headerNew.vue'
  import footerComponent from './components/footerNew.vue'
  import locale from "element-ui/lib/locale";
  import elementZhLocale from "element-ui/lib/locale/lang/zh-CN";
  import elementEnLocale from "element-ui/lib/locale/lang/en";

  export default {
    name: 'App',
    components: {headerComponent, footerComponent},
    data() {
      return {
      }
    },
    created(){
      //在页面加载时读取localStorage里的状态信息
      localStorage.getItem("lang") && this.$store.replaceState(Object.assign(this.$store.state,JSON.parse(localStorage.getItem("lang"))));
      //在页面刷新时将vuex里的信息保存到localStorage里
      window.addEventListener("beforeunload",()=>{
        localStorage.setItem("lang",JSON.stringify(this.$store.state))
      })
      //设置浏览器title
      window.document.title="数据恢复技术网";
      var language=this.$store.state.lang;
      if(language === "en"){
        window.document.title="Data recovery technology website";
      }else if(language === "zh"){
        window.document.title="数据恢复技术网";
      }
    },
    mounted() {
      window.addEventListener('scroll', this.scrollToTop)
    },
    destroyed() {
      window.removeEventListener('scroll', this.scrollToTop);
    },
    methods: {
        scrollToTop() {
        let topBtn = document.getElementById('back-top');
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        let browserHeight = document.body.clientHeight;
        if (scrollTop > browserHeight) {
          topBtn.style.display = 'block';
        } else {
          topBtn.style.display = 'none';
        }
      },
      goTop() {
        let that = this;
        let timer = setInterval(() => {
          document.documentElement.scrollTop = 0;
          that.scrollTop = document.documentElement.scrollTop;
          if (that.scrollTop < 10) {
            clearInterval(timer);
          }
        }, 30)
      }
    },
  }
</script>

<style>
  html, body {
    height: 100%;
    margin: 0 0;
    padding: 0 0;
    background: #fff;
  }

  ul, li {
    list-style: none;
    padding: 0 0;
    margin: 0 0;
  }
  #app {
    height: 100%;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    color: #2c3e50;
  }

  /*返回顶部*/
  .back-top {
    position: fixed;
    right: 30px;
    bottom: 30px;
    background: #00af42;
    border-radius: 50%;
    color: #fff;
    width: 40px;
    height: 40px;
    border: none;
    font-size: 14px;
    display: none;
  }

  .back-top:hover {
    background: #00a642;
    cursor: pointer
  }

  .back-top:focus {
    outline: none;
    border: none;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue